/**
 * Favorite Cell Renderer
 *
 * Generates HTML for favorite toggle and action buttons
 */

import type { Lot, State } from '../../types';
import { escapeAttr } from '../formatting';
import styles from './tableCells.module.css';

export function buildFavoriteCell(
  lot: Lot,
  state: State,
  isDeleted: boolean,
  editIconButton: string
): string {
  const l = lot;

  const isFav = !!l.favorite;
  const isPending = state.pendingFavoriteIds && state.pendingFavoriteIds.has(l.id);
  let starTitle = isFav ? 'Remove from favorites' : 'Add to favorites';
  if (isDeleted) {
    starTitle = 'Favorites unavailable for deleted lots';
  }
  const favoriteDisabled = isPending || isDeleted;
  let favoriteDisabledAttrs = favoriteDisabled ? ' disabled' : '';
  if (isDeleted) {
    favoriteDisabledAttrs += ' aria-disabled="true"';
  }
  const favoriteButton =
    '<button class="' +
    styles.favoriteToggle +
    '" data-action="favorite" data-id="' +
    escapeAttr(l.id) +
    '" aria-pressed="' +
    (isFav ? 'true' : 'false') +
    '" title="' +
    escapeAttr(starTitle) +
    '"' +
    favoriteDisabledAttrs +
    '>' +
    (isFav ? '★' : '☆') +
    '</button>';

  const detailsTitle = isDeleted ? 'View details (deleted lot)' : 'View details';
  const detailsIconButton =
    '<button class="' +
    styles.lotActionButton +
    '" data-action="view-details" data-id="' +
    escapeAttr(l.id) +
    '" title="' +
    escapeAttr(detailsTitle) +
    '" aria-label="' +
    escapeAttr(detailsTitle) +
    '"><span aria-hidden="true">🗂️</span></button>';

  const deleteTitle = isDeleted ? 'Lot already deleted' : 'Delete lot';
  const deleteDisabledAttrs = isDeleted ? ' disabled aria-disabled="true"' : '';
  const deleteIconButton =
    '<button class="' +
    styles.lotActionButton +
    ' ' +
    styles.lotActionButtonDelete +
    '" data-action="delete" data-id="' +
    escapeAttr(l.id) +
    '" title="' +
    escapeAttr(deleteTitle) +
    '" aria-label="' +
    escapeAttr(deleteTitle) +
    '"' +
    deleteDisabledAttrs +
    '><span aria-hidden="true">🗑️</span></button>';

  return (
    '<div class="' +
    styles.favoriteActions +
    '">' +
    favoriteButton +
    detailsIconButton +
    deleteIconButton +
    (editIconButton || '') +
    '</div>'
  );
}
